import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import PayerDataService from '../../../../services/PayerDataService';
import { componentKey, setExportFile, setFilingStatuses, setFormCategory, setHistory, setLoadingState, setPayersList, setTotalHistory} from './FilingHistorySlice';
import ManageFormsService from '../../../../services/ManageFormsService';
import HistoryDataService from '../../../../services/HistoryDataService';
import Payer from '../../../../libs/utility/Payer';
import General from '../../../../libs/utility/General';

export const { getPayerList, getFilingHistory, getFilingStatuses, getCategoryList } = {
    getPayerList: (payload) => {
        return {
            type: "FILING/GET_PAYERS",
            payload: payload
        }
    },
    getFilingHistory: (payload) => {
        return {
            type: "FILING/GET_FILING_HISTORY",
            payload: payload
        }
    },
    getFilingStatuses: (payload) => {
        return {
            type: "FILING/GET_FILING_STATUS",
            payload: payload
        }
    },
    getCategoryList: (payload) => {
        return {
            type: "FILING/GET_CATEGORY_LIST",
            payload: payload
        }
    },
}

function* getPayerListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Payers......" }));
        const response = yield ManageFormsService.getFederalPayers();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setPayersList(response.data.Data.map(payer => ({label: payer.LastName, value: payer.PayerDetailId}))));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getFilingHistoryAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting Filing History......" }));
        const response = yield HistoryDataService.GetFilingHistoryData(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHistory([...General.extractDataFromResponseData(response.data)]));
            yield put(setTotalHistory(General.extractPaginationTotalFromResponse(response.data)));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* getFilingStatusesAsync() {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Getting Filing Statuses......" }));
        const response = yield HistoryDataService.getFilingStatuses();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setFilingStatuses(response.data.Data.map(status => ({id: status.Id, value: status.Value}))));
        }
    } catch (error) {
        yield put(setFilingStatuses(error.response.data.Data.map(status => ({id: status.Id, value: status.Value}))));
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getCategoryListAsync() {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY, message: "Getting Filing Statuses......" }));
        const response = yield HistoryDataService.get94XFormList();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setFormCategory(response.data.Data));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPayerList().type, getPayerListAsync),
        takeLatest(getFilingHistory().type, getFilingHistoryAsync),
        takeLatest(getFilingStatuses().type, getFilingStatusesAsync),
        takeLatest(getCategoryList().type, getCategoryListAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);